//
// Web Sockets
// ---------------------------------------------------------------------------

// Default interval for the socket ping/pong cycle
export const SOCKET_PING_INTERVAL: number = 10000;

// Default timeout for the socket ping/pong cycle
export const SOCKET_PING_TIMEOUT: number = 30000;

// Delay between socket reconnection attempts. Exponential backoff is better for
// reconnection, starting with 1000ms.
export const SOCKET_RECONNECTION_DELAY: number = 1000;

// Socket connection retry strategy. Still using Infinity, but our custom
// heartbeat mechanism will handle extreme cases.
export const SOCKET_RECONNECTION_ATTEMPTS: number = Infinity;

// Connection timeout on socket before error. Matches `SOCKET_PING_TIMEOUT`.
export const SOCKET_TIMEOUT: number = SOCKET_PING_TIMEOUT;

// Enable / disable automatic socket reconnection
export const SOCKET_AUTOMATICALLY_RECONNECT: boolean = true;

// Application-level heartbeat interval (5 seconds). Custom heartbeat for more
// reliable connection monitoring.
export const SOCKET_HEARTBEAT_INTERVAL: number = 5000;

// Application-level heartbeat timeout (3x interval). After this time without a
// heartbeat response, connection is considered dead.
export const SOCKET_HEARTBEAT_TIMEOUT: number = 3 * SOCKET_HEARTBEAT_INTERVAL;
